export default "__VITE_ASSET__Bs9gn8Yk__"